import React, { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
export default function CustomCursor(props) {
    //const { children } = props;
    var isVisibleRef = useRef(props.isVisible);
    var _a = useState({ x: 0, y: 0 }), cursorXY = _a[0], setCursorXY = _a[1];
    var _b = useState(50), cursorRadius = _b[0], setCursorRadius = _b[1];
    //const [cursorIsVisible, setCursorIsVisible] = useState(false);   
    //const [cursorContent, setCursorCursorContent] = useState("");
    var getIsVisible = function () { return props.isVisible; };
    useEffect(function () {
        isVisibleRef.current = props.isVisible;
    }, [props && props.isVisible]);
    useEffect(function () {
        var moveCursor = function (e) {
            // if (!props.isVisible) return;
            // console.log("move cursor: isVisible:", isVisibleRef.current);
            var x = e.clientX;
            var y = e.clientY;
            setCursorXY({ x: x, y: y });
            //setCursorIsVisible(true);
        };
        window.addEventListener('mousemove', moveCursor);
        return function () {
            window.removeEventListener('mousemove', moveCursor);
        };
    }, []);
    var container = {
        hidden: {
            opacity: 0,
            scale: .5,
            height: cursorRadius * 2,
            width: cursorRadius * 2,
            borderRadius: cursorRadius,
            x: cursorXY.x - cursorRadius,
            y: cursorXY.y - cursorRadius,
            transition: {
                duration: 0.1
            }
        },
        show: {
            scale: 1,
            borderRadius: cursorRadius,
            x: cursorXY.x - cursorRadius,
            y: cursorXY.y - cursorRadius,
            height: cursorRadius * 2,
            width: cursorRadius * 2,
            opacity: 1,
            transition: {
                duration: 0.3,
                ease: "easeOut",
                x: {
                    duration: 0
                },
                y: {
                    duration: 0
                },
                scale: {
                    type: "spring",
                    //damping: 5,
                    //stiffness: 100,
                    restDelta: 0.01
                    //damping: 7,
                    //stiffness: 100,
                    //restDelta: 0.01
                }
            }
        }
    };
    return (React.createElement(React.Fragment, null, (cursorXY.x > 0 && cursorXY.y > 0) &&
        React.createElement(motion.div, { className: "cursor", initial: "hidden", animate: props.isVisible ? "show" : "hidden", variants: container, style: {
                //transform: `translate3d(${cursorXY.x}px, ${cursorXY.y}px, 0)`,
                mixBlendMode: 'normal',
                color: props.cursorTextColor || 'black',
                backgroundColor: props.cursorBackgroundColor || 'white' //(cursorIsInsideBanner && cursorContent.length > 0) ? cursorBackgroundColor : 'white',              
            } },
            React.createElement("span", null, props.cursorContent)) || null));
}
